import React, { useState } from 'react';
import './imageGallery.css'
import Lightbox from 'react-18-image-lightbox';
import 'react-18-image-lightbox/style.css'
import { API_URI } from '../../../axios';

function ImageGallery(props) {
  const [isOpen, setIsOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);

  // Open Lightbox
  const openLightbox = (index) => {
    setIsOpen(true);
    setPhotoIndex(index);
  };

  // Close Lightbox
  const closeLightbox = () => {
    setIsOpen(false);
  };

  return (
    <>
    
      {props.data && props.data.map((img, index) => {
        return (
            <div key={index} className='gallery-item gallery-style-2'>
            <div className=" gallery-image relative">
                <img
                  className="img-fluid"
                  key={index}
                  src={`${API_URI}${img.src}`}
                  alt={props.data.title}
                  // cat={img.category}
                  //alt={`Image ${index}`}
                  onClick={() => openLightbox(index)}
                />
                
              </div>
                {/* <div className="gallery-overlay" onClick={() => openLightbox(index)}>
                  <div className='overlay-text'>{img.title}</div>
                </div> */}
            
            </div>
          
        )
      }) }
    {/* </Slider> */}
      

      {isOpen && (
        <Lightbox
          imagePadding={50}
          mainSrc={`${API_URI}${props.data[photoIndex].src}`}
          imageTitle=''
          nextSrc={props.data[(photoIndex + 1) % props.data.length].src}
          prevSrc={
            props.data[(photoIndex + props.data.length - 1) % props.data.length].src
          }
          onCloseRequest={closeLightbox}
          onMovePrevRequest={() =>
            setPhotoIndex(
              (photoIndex + props.data.length - 1) % props.data.length
            )
          }
          onMoveNextRequest={() =>
            setPhotoIndex((photoIndex + 1) % props.data.length)
          }
        />
      )}
    </>
  );
}

export default ImageGallery;
